var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property } from "lit/decorators.js";
import { html, LitElement, svg } from "lit";
import Snap from "snapsvg-cjs";
import oauthModalCss from "./electric-box.css.js";
let ElectricBox = class ElectricBox extends LitElement {
    constructor() {
        super();
        this.svgWidth = 0;
        this.svgHeight = 0;
        this.activePixelCount = 0;
        this.spin = false;
        this.spinamount = 20;
        this.squares = false;
        this.orbs = false;
        this.color = 'var(--secondary-color)';
        this.mintraveltime = 1000;
        this.maxtraveltime = 4000;
        this.heroView = false;
        this.height = 500;
        this.disable = false;
    }
    render() {
        return html `
      <div id="container">
          <div id="box-content">
              <slot></slot>    
          </div>
          
        <svg
          id="electric-box"
          xmlns="http://www.w3.org/2000/svg"
          width="100%"
          height="${this.height}px"
          preserveAspectRatio="none"
        >
          <defs>
            <radialGradient id="radial-gradient" cx="0.5" cy="0.5" r="0.5" gradientUnits="objectBoundingBox">
              ${this.renderColorStops()}
            </radialGradient>
          </defs>

          <g id="box-group">
            <path id="orb-path" fill="none" stroke="${this.color}" stroke-width="${this.heroView ? 5 : 2}" />
          </g>
          <g id="orb-group">
            <circle
              id="orb-circle"
              cx="100"
              cy="100"
              r="20"
              style="fill: url(#radial-gradient); display: none;"
            />
          </g>
        </svg>
      </div>
    `;
    }
    firstUpdated() {
        const containerDiv = this.shadowRoot.getElementById("container");
        if (!containerDiv)
            return;
        this.pixelConfig = {
            pixelColor: this.color,
            pixelSize: 1,
            spawnIntervalMs: 20,
            minTravelMs: this.mintraveltime,
            maxTravelMs: this.maxtraveltime,
            maxActivePixels: 5000
        };
        const rect = containerDiv.getBoundingClientRect();
        this.svgWidth = Math.floor(rect.width);
        this.svgHeight = Math.floor(rect.height);
        if (this.svgHeight <= 0) {
            this.svgHeight = 280;
        }
        if (this.svgWidth <= 0) {
            this.svgWidth = 500;
        }
        const heroPath = `M 0,0 H ${this.svgWidth} M 0,${this.svgHeight} H ${this.svgWidth}`;
        const regularPath = `M 0,0 H ${this.svgWidth} V ${this.svgHeight} H 0 Z`;
        const dynamicPath = this.heroView ? heroPath : regularPath;
        this.container = Snap(this.shadowRoot.querySelector("#electric-box"));
        this.container.attr({ viewBox: `0 0 ${this.svgWidth} ${this.svgHeight}` });
        this.orbPath = this.container.select("#orb-path");
        this.orbPath.attr({ d: dynamicPath });
        this.orbGroup = this.container.select("#orb-group");
        this.orb = this.container.select("#orb-circle");
        this.orb.attr({ display: "none" });
    }
    updated() {
        if (this.disable) {
            this.stopAnimation();
        }
        else {
            this.runAnimation();
        }
    }
    runAnimation() {
        // Ensure timers have not already been started.
        if (!this.pixelSpawnTimer && !this.disable) {
            if (this.orbs) {
                this.orbTimer = setInterval(() => {
                    this.spawnOrb();
                }, 500);
            }
            this.pixelSpawnTimer = setInterval(() => {
                if (this.activePixelCount < this.pixelConfig.maxActivePixels) {
                    this.spawnPixel();
                }
            }, this.pixelConfig.spawnIntervalMs);
        }
    }
    stopAnimation() {
        // Clear the animation timers if they exist.
        if (this.pixelSpawnTimer) {
            clearInterval(this.pixelSpawnTimer);
            this.pixelSpawnTimer = null;
        }
        if (this.orbTimer) {
            clearInterval(this.orbTimer);
            this.orbTimer = null;
        }
    }
    willUpdate() {
        if (this.orbTimer && !this.orbs) {
            clearInterval(this.orbTimer);
        }
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.stopAnimation();
    }
    getRandomBorderPosition() {
        // If heroView is true, only spawn pixels on the top (edge 0) or bottom (edge 1)
        if (this.heroView) {
            const topOrBottom = Math.random() < 0.5 ? 0 : 1;
            if (topOrBottom === 0) {
                // Top edge
                return { x: Math.random() * this.svgWidth, y: 0 };
            }
            else {
                // Bottom edge
                return { x: Math.random() * this.svgWidth, y: this.svgHeight };
            }
        }
        const edge = Math.floor(Math.random() * 4);
        let x = 0, y = 0;
        switch (edge) {
            case 0:
                x = Math.random() * this.svgWidth;
                y = 0;
                break;
            case 1:
                x = this.svgWidth;
                y = Math.random() * this.svgHeight;
                break;
            case 2:
                x = Math.random() * this.svgWidth;
                y = this.svgHeight;
                break;
            case 3:
                x = 0;
                y = Math.random() * this.svgHeight;
                break;
        }
        return { x, y };
    }
    spawnPixel() {
        const { x, y } = this.getRandomBorderPosition();
        let newPixel;
        if (Math.random() < 0.1) {
            if (this.squares) {
                newPixel = this.container.rect(x - (this.pixelConfig.pixelSize + 6) / 2, y - (this.pixelConfig.pixelSize + 6) / 2, this.pixelConfig.pixelSize + 6, this.pixelConfig.pixelSize + 6);
                newPixel.attr({
                    opacity: 1,
                    fill: "url(#radial-gradient)"
                });
            }
            else {
                newPixel = this.container.circle(x, y, this.pixelConfig.pixelSize + 6);
                newPixel.attr({
                    opacity: 1,
                    fill: "url(#radial-gradient)"
                });
            }
        }
        else {
            if (this.squares) {
                newPixel = this.container.rect(x - this.pixelConfig.pixelSize / 2, y - this.pixelConfig.pixelSize / 2, this.pixelConfig.pixelSize, this.pixelConfig.pixelSize);
                newPixel.attr({
                    fill: this.pixelConfig.pixelColor,
                    opacity: 1
                });
            }
            else {
                newPixel = this.container.circle(x, y, this.pixelConfig.pixelSize);
                newPixel.attr({
                    fill: this.pixelConfig.pixelColor,
                    opacity: 1
                });
            }
        }
        this.activePixelCount++;
        this.animatePixelToCenter(newPixel);
    }
    animatePixelToCenter(pixel) {
        const travelTime = this.getRandomValue(this.maxtraveltime, this.maxtraveltime);
        const centerX = this.svgWidth / 2;
        const centerY = this.svgHeight / 2;
        const fadeStart = 0.2;
        const fadeDuration = 0.4;
        const fadeEnd = fadeStart + fadeDuration;
        let startX = 0;
        let startY = 0;
        if (this.squares) {
            startX = +pixel.attr("x") + (+pixel.attr("width") / 2);
            startY = +pixel.attr("y") + (+pixel.attr("height") / 2);
        }
        else {
            startX = +pixel.attr("cx");
            startY = +pixel.attr("cy");
        }
        Snap.animate(0, 1, (t) => {
            const x = startX + (centerX - startX) * t;
            const y = startY + (centerY - startY) * t;
            let opacity = 1;
            if (t >= fadeEnd) {
                opacity = 0;
            }
            else if (t >= fadeStart) {
                opacity = 1 - ((t - fadeStart) / fadeDuration);
            }
            if (this.squares) {
                const halfW = +pixel.attr("width") / 2;
                const halfH = +pixel.attr("height") / 2;
                pixel.attr({ x: x - halfW, y: y - halfH, opacity });
                if (this.spin) {
                    const angle = t * this.spinamount;
                    pixel.transform(`r${angle},${x},${y}`);
                }
            }
            else {
                pixel.attr({ cx: x, cy: y, opacity });
                if (this.spin) {
                    const angle = t * this.spinamount;
                    pixel.transform(`r${angle},${centerX},${centerY}`);
                }
            }
        }, travelTime, mina.easeinout, () => {
            pixel.remove();
            this.activePixelCount--;
        });
    }
    spawnOrb() {
        if (!this.orb || !this.orbPath)
            return;
        const totalLength = this.orbPath.getTotalLength();
        const randomDistance = Math.random() * totalLength;
        const point = this.orbPath.getPointAtLength(randomDistance);
        const clonedOrb = this.orb.clone();
        this.orbGroup.add(clonedOrb);
        clonedOrb.attr({
            cx: point.x,
            cy: point.y,
            opacity: "0",
            display: "block"
        });
        this.pulseOnce(clonedOrb);
        this.loopAroundPath(clonedOrb);
    }
    pulseOnce(orb) {
        orb.animate({ opacity: 1 }, this.getRandomValue(200, 800), mina.easeinout, () => {
            orb.animate({ opacity: 0 }, this.getRandomValue(1500, 3000), mina.easeinout, () => {
                orb.remove();
            });
        });
    }
    loopAroundPath(orb) {
        const totalLength = this.orbPath.getTotalLength();
        const randomStart = Math.random() * totalLength;
        const directionIsCW = Math.random() < 0.5;
        let lapsDone = 0;
        const maxLaps = 2;
        const animateOneLap = (startDistance) => {
            const endDistance = directionIsCW
                ? startDistance + totalLength
                : startDistance - totalLength;
            Snap.animate(startDistance, endDistance, (val) => {
                const modVal = ((val % totalLength) + totalLength) % totalLength;
                const p = this.orbPath.getPointAtLength(modVal);
                orb.attr({ cx: p.x, cy: p.y });
            }, this.getRandomValue(2200, 4500), mina.easeinout, () => {
                lapsDone++;
                if (lapsDone < maxLaps) {
                    animateOneLap(endDistance);
                }
                else {
                    orb.remove();
                }
            });
        };
        animateOneLap(randomStart);
    }
    getRandomValue(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min) + min);
    }
    renderColorStops() {
        return svg `
          <stop offset="0%" stop-color="#fff" stop-opacity="1"/>
          <stop offset="20%" stop-color="${this.color}" stop-opacity="0.8"/>
          <stop offset="50%" stop-color="${this.color}" stop-opacity="0.4"/>
          <stop offset="40%" stop-color="${this.color}" stop-opacity="0.2"/>
          <stop offset="100%" stop-color="${this.color}" stop-opacity="0"/>
        `;
    }
};
ElectricBox.styles = [oauthModalCss];
__decorate([
    property({ type: Boolean })
], ElectricBox.prototype, "spin", void 0);
__decorate([
    property({ type: Number })
], ElectricBox.prototype, "spinamount", void 0);
__decorate([
    property({ type: Boolean })
], ElectricBox.prototype, "squares", void 0);
__decorate([
    property({ type: Boolean })
], ElectricBox.prototype, "orbs", void 0);
__decorate([
    property({ type: Number })
], ElectricBox.prototype, "mintraveltime", void 0);
__decorate([
    property({ type: Number })
], ElectricBox.prototype, "maxtraveltime", void 0);
__decorate([
    property({ type: Number })
], ElectricBox.prototype, "height", void 0);
__decorate([
    property({ type: Boolean })
], ElectricBox.prototype, "heroView", void 0);
__decorate([
    property({ type: Boolean, attribute: 'disable' })
], ElectricBox.prototype, "disable", void 0);
__decorate([
    property()
], ElectricBox.prototype, "color", void 0);
ElectricBox = __decorate([
    customElement("pb33f-electric-box")
], ElectricBox);
export { ElectricBox };
